<template>
  <div>
    <el-drawer
      v-if="visible"
      visible
      show-close
      size="1000px"
      :title="'数据导入'"
      :before-close="() => $refs.main.cancel()"
      append-to-body
    >
      <Main ref="main" @close="close" @reload="$emit('reload')" />
    </el-drawer>
  </div>
</template>
<script>
import Main from './Main.vue'

export default {
  components: {
    Main,
  },
  props: {
    visible: {
      default: false,
    },
  },

  data() {
    return {}
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
